import { BaseViewStore } from 'core/stores';
import { ApplicationStore } from 'platform/application/stores';
import { WarehouseOrganizationInfoStore } from 'modules/warehouse/stores';
import { CloseOutExitForm } from 'modules/order/forms';
import { notificationError, isSome } from 'core/utils';
import { localStorageHandler } from 'core/services';
import { observable, action, makeObservable } from 'mobx';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';

class CloseOutExitViewStore extends BaseViewStore {
	@observable disableSaveBtn = true;
	@observable warehouseOptions = [];
	@observable responseArray = [];
	@observable isWarehouseDropdownLoading = false;

	debouncedOnCheck = null;
	debouncedWarehouseSearch = null;

	form = new CloseOutExitForm({
		onSuccess: () => {
			this.closeOutExit;
		},
	});

	constructor(rootStore) {
        super(rootStore);
        makeObservable(this);
        this.applicationStore = new ApplicationStore(rootStore);
        this.warehouseOrganizationInfoStore = new WarehouseOrganizationInfoStore(rootStore);
        this.initialize();
    }

	@action.bound async initialize() {
		this.suspend();
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: false,
		});
		this.debouncedWarehouseSearch = _.debounce((searchPhrase, { action }) => {
			this.searchWarehouseAsync(searchPhrase, { action });
		}, 500);

		await this.getWarehouseOptions();
		this.resume();
	}

	@action.bound
	async handleOnWarehouseMenuScroll() {
		if (this.warehouseOptions.length < this.pageWarehouse * 15) return;
		this.isWarehouseDropdownLoading = true;
		this.pageWarehouse++;

		await this.applicationStore.find({
			rpp: 15,
			page: this.pageWarehouse,
			warehouseOnly: true,
			isOrganizationActive: true,
		});
		this.responseArray = [...this.responseArray, ...this.applicationStore.response.item];
		const newOptions = _.map(this.responseArray, item => {
			return { value: item.id, label: item.applicationTitle };
		});
		if (newOptions.length > this.warehouseOptions.length) {
			this.warehouseOptions = [...newOptions];
		}
		this.isWarehouseDropdownLoading = false;
	}

	@action.bound
	async searchWarehouseAsync(searchPhrase, { action }) {
		if (searchPhrase === '') {
			this.pageWarehouse = 1;
		}
		if (action === 'input-change') {
			this.isWarehouseDropdownLoading = true;
			this.infiniteSearchPhrase = searchPhrase;
			this.pageWarehouse = 1;
			this.warehouseOptions = [];
			let filter = {
				search: searchPhrase || null,
				rpp: 15,
				page: 1,
				warehouseOnly: true,
				isOrganizationActive: true,
			};
			await this.applicationStore.find(filter);
			this.responseArray = [...this.applicationStore.response.item];
			const newOptions = [];
			_.forEach(this.responseArray, item => {
				newOptions.push({ value: item.id, label: item.applicationTitle, extra: item });
			});
			this.warehouseOptions = newOptions;
			this.isWarehouseDropdownLoading = false;
		}
	}

	@action.bound
	async onMenuClose() {
		this.pageWarehouse = 1;
		this.infiniteSearchPhrase = null;
		await this.getWarehouseOptions(false);
	}

	@action.bound async getWarehouseOptions() {
		this.pageWarehouse = 1;
		await this.applicationStore.find({
			page: this.pageWarehouse,
			rpp: 15,
			warehouseOnly: true,
			isOrganizationActive: true,
			useSafeQuantity: false,
		});
		this.responseArray = [...this.applicationStore.response.item];
		this.warehouseOptions = _.map(this.responseArray, item => {
			return { label: item.applicationTitle, value: item.id, extra: item };
		});
	}

	@action.bound
	async closeOutExit() {
		this.suspend();
		try {
			const response = await this.warehouseOrganizationInfoStore.closeOutExitScan(
				sourceOfChange.closeOutExitScan,
				this.form.$('warehouse').value.value
			);
			if (response) {
				this.rootStore.notificationStore.success('WAREHOUSEVIEW.CLOSEOUT.EXITSCAN.SUCCESS');
			} else {
				this.rootStore.notificationStore.error('WAREHOUSEVIEW.CLOSEOUT.EXITSCAN.FAILURE');
				this.setCloseOutFlag(false);
				this.setCloseOutWarehouse(this.form.$('warehouse').value);
				this.rootStore.routerStore.goTo('master.app.main.order.closeout.detail');
			}
		} catch (err) {
			if (err.data) {
				this.rootStore.notificationStore.error(err.data);
			} else {
				notificationError({ store: this.rootStore.notificationStore, err });
			}
		}
		this.resume();
	}

	onWarehouseSelect = async item => {
		this.form.$('warehouse').value = item;
		await this.getWarehouseOptions(false);
		this.disableSaveBtn = false;
	};

	setCloseOutWarehouse = warehouse => {
		localStorageHandler.set('closeOutWarehouse', warehouse);
	};

	setCloseOutFlag = flag => {
		localStorageHandler.set('isCloseOutPalletizing', flag);
	};
}

export default CloseOutExitViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/CloseOutExitViewStore.js